import { render, staticRenderFns } from "./servicosEditar.vue?vue&type=template&id=72dc924d&scoped=true&"
import script from "./servicosEditar.vue?vue&type=script&lang=js&"
export * from "./servicosEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc924d",
  null
  
)

export default component.exports